import React from 'react';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';

export const MobilePage = () => {
  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />
      <ResultsMobileContainer />
      <ResultsEmptyContainer />
      <ShowMoreBtnContainer />
    </>
  );
};
